<template>
	<svg width="20" height="15" xmlns="http://www.w3.org/2000/svg" @click="$emit('click')">
		<path d="M20 2.48v-.315A2.157 2.157 0 0 0 17.845.01H2.155A2.157 2.157 0 0 0 0 2.165v10.67c0 1.188.967 2.154 2.155 2.154h15.69A2.157 2.157 0 0 0 20 12.835V2.48zM2.155 1.183h15.69c.542 0 .983.441.983.983L10.98 7.398c-.522.349-1.438.348-1.96 0L1.172 2.166c0-.543.44-.984.983-.984zm15.69 12.636H2.155a.984.984 0 0 1-.983-.983V3.574l7.197 4.798c.458.305 1.044.457 1.631.457s1.173-.152 1.63-.457l7.198-4.798v9.26a.984.984 0 0 1-.983.984z" fill="#F09C2B" fill-rule="nonzero"/>
	</svg>

</template>

<script>
export default {
	name: 'envelope-icon',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/envelope-icon.vue